/* eslint-disable react/display-name */
import * as React from 'react';
import { CheckboxButtonGroup } from '../../CheckboxButtonGroup';
import { IExtraFilterStoreProps, IExtraFilterDispatchProps } from './creators';

export type IExtraFilterProps<T> = IExtraFilterStoreProps<T> & IExtraFilterDispatchProps<T>;

export function createExtraFilter<T extends string>(options: { value: T; label: string }[], anyOption?: boolean) {
  return ({ selected, toggle }: IExtraFilterProps<T>) => {
    return <CheckboxButtonGroup options={options} value={selected} onChange={toggle} anyOption={anyOption} />;
  };
}
